export default __webpack_public_path__ + "static/media/image-homepage-profile.babfb693.jpg";